import { useSyncExternalStore } from 'react';

import { useInject } from '@vk-hr-tek/core/ioc';
import { DegradationService } from '@vk-hr-tek/core/degradation';

/**
 * Хук для определения, работает ли сервис в режиме деградации
 * @returns true, если хотя бы один HTTP-ответ содержал признак деградации
 */
export const useIsServiceDegraded = (): boolean => {
  const degradation = useInject(DegradationService);

  return useSyncExternalStore(degradation.subscribe, degradation.isDegraded);
};
